import { useCallback, useEffect } from "react"
import { useComputed, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { companyUsers } from "@signals"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { isLoadingMonth, monthSearches } from "Pages/Main/Home/@signals"


export default function useSearchAnalyticsWeekInfo() {
	const weekSearches = useSignal(0)
	const isLoadingWeek = useSignal(false)
	const todaySearches = useSignal(0)
	const isLoadingToday = useSignal(false)
	const isLoading = useComputed(() => isLoadingToday.value || isLoadingWeek.value || isLoadingMonth.value)
	const data = useComputed(() => {
		if (!isLoading.value) {
			return { weekSearches: weekSearches.value, monthSearches: monthSearches.value, todaySearches: todaySearches.value }
		}
		return {}
	})
	const { showToast } = useToast()

	useEffect(() => {
		getWeekInfo()
	}, [JSON.stringify(companyUsers.value)])


	const getWeekInfo = useCallback(() => {
		isLoadingWeek.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/week`, {
			uid: companyUsers.value
		}).then(({ searches }) => {
			weekSearches.value = searches
			isLoadingWeek.value = false
		})
		isLoadingToday.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/day`, {
			uid: companyUsers.value
		}).then(({ searches }) => {
			todaySearches.value = searches
			isLoadingToday.value = false
		}).catch(() => showToast.error())
	}, [JSON.stringify(companyUsers.value)])

	return {
		isLoading: isLoading.value,
		data: data.value
	}
}